import { Box3D } from './types'

export type BoxAction = 
  | { type: 'create'; box: Box3D }
  | { type: 'update'; id: string; patch: Partial<Box3D> }
  | { type: 'delete'; id: string }
  | { type: 'bulkSet'; boxes: Box3D[] }

export function boxReducer(state: Box3D[], action: BoxAction): Box3D[] {
  switch (action.type) {
    case 'create':
      return [...state, action.box]
    
    case 'update':
      return state.map(box => 
        box.id === action.id 
          ? { ...box, ...action.patch }
          : box
      )
    
    case 'delete':
      return state.filter(box => box.id !== action.id)
    
    case 'bulkSet':
      return action.boxes
    
    default:
      return state
  }
}

export const newBox = (init: Partial<Box3D>): Box3D => {
  return {
    id: crypto.randomUUID(),
    frameId: 0,
    cx: 0,
    cy: 0,
    cz: 0,
    lx: 1,
    ly: 1,
    lz: 1,
    yaw: 0,
    cls: 'unknown',
    locked: false,
    ...init
  }
}
